import { ImageOptimization } from '@components/image-optimization'
import ModalVideo from '@components/shared/modal-video'
import { BlockCall } from '@services/api/block-calls'
import { HTMLAttributes, useState } from 'react'
import ReactPlayer from 'react-player'
import styles from './styles.module.scss'

interface Props extends HTMLAttributes<HTMLDivElement> {
  blockCall: BlockCall
}

export const BloclCallVideo = ({ blockCall }: Props) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div>
        <picture
          className={styles.containerImage}
          onClick={() => setShowModal(true)}
        >
          <ImageOptimization
            src={blockCall.imageUrl}
            alt={blockCall.imageAlt}
            className={styles.image}
            width="100%"
            height="100%"
          />
          <ImageOptimization
            className={`lg:block absolute`}
            src="/assets/youtube-brands.svg"
            width="57"
            height="40"
          />
          <div
            className={styles.overlay}
            onClick={() => setShowModal(true)}
          ></div>
        </picture>

        <span className="my-3 text-lg font-bold block">{blockCall.title}</span>
        <p className="text-sm font-normal">{blockCall.description}</p>
      </div>
      <ModalVideo showModal={showModal} setShowModal={setShowModal}>
        <ReactPlayer playing width="100%" url={blockCall.buttonLink} />
      </ModalVideo>
    </>
  )
}
